<div class="row container">
    <table datatable  class="table-striped table-sm row-border hover" id="table1">
        <thead>
            <tr>
                <th>No.</th>
                <th>Name</th>
                <th>Surname</th>
                <th>Email</th>
                <th>Telephone</th>
                <th>Date of Birth</th>
                <th>Place of Birth</th>
                <th>Fiscal Code</th>
                <th>Qualification</th>
                <th>Business Function</th>
            </tr>
        </thead>
        <tbody #trRef>
            <tr  #trRef>
                <td>1</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>

            </tr>
        </tbody>
        <tbody *ngIf="data?.length == 0">
            <tr>
                <td colspan="3" class="no-data-available">No data!</td>
            </tr>
        </tbody>
    </table>
</div>
<!-- 

<div class="container">
	<table datatable [dtOptions]="dtOptions" class="row-border hover">
		<thead>
			<tr>
				<th>ID</th>
				<th>First name</th>
				<th>Last name</th>
			</tr>
		</thead>
		<tbody *ngIf="data?.length != 0">
			<tr *ngFor="let person of data">
				<td>{{ person.id }}</td>
				<td>{{ person.firstName }}</td>
				<td>{{ person.lastName }}</td>
			</tr>
		</tbody>
		<tbody *ngIf="data?.length == 0">
			<tr>
				<td colspan="3" class="no-data-available">No data!</td>
			</tr>
		</tbody>
	</table>
</div> -->